const CardBody = ({ children, ...rest }) => {
    return (
        <div className="card-body" {...rest}>
            {children}
        </div>
    );
};

export default CardBody;
